import React from 'react';
import PropTypes from 'prop-types';

const Digilocker = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.53516 17.7643V23.4251C5.53516 23.7163 5.65084 23.9956 5.85676 24.2015C6.06269 24.4074 6.34198 24.5231 6.6332 24.5231H21.4567C21.7479 24.5231 22.0272 24.4074 22.2332 24.2015C22.4391 23.9956 22.5548 23.7163 22.5548 23.4251V9.15054H17.6136C17.3224 9.15054 17.0431 9.03486 16.8372 8.82893C16.6312 8.62301 16.5155 8.34372 16.5155 8.0525V3.11133H6.6332C6.34198 3.11133 6.06269 3.22701 5.85676 3.43294C5.65084 3.63886 5.53516 3.91815 5.53516 4.20937V11.9697"
      stroke={fill || '#6B6C7B'}
      strokeWidth="2.17778"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5156 3.11133L22.5548 9.15054"
      stroke={fill || '#6B6C7B'}
      strokeWidth="2.17778"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8124 12.677C14.7891 12.677 14.7666 12.6799 14.7435 12.6804C14.6037 11.8657 14.2126 11.115 13.625 10.5335C13.0373 9.9521 12.2825 9.56899 11.4663 9.43787C10.6501 9.30674 9.81328 9.43416 9.07308 9.80229C8.33288 10.1704 7.72633 10.7608 7.33838 11.4908C7.3145 11.4903 7.29133 11.4872 7.26734 11.4872C6.37126 11.4872 5.51188 11.8432 4.87826 12.4768C4.24464 13.1104 3.88867 13.9698 3.88867 14.8659C3.88867 15.762 4.24464 16.6213 4.87826 17.255C5.51188 17.8886 6.37126 18.2445 7.26734 18.2445H14.8124C15.5507 18.2445 16.2588 17.9513 16.7808 17.4292C17.3029 16.9071 17.5962 16.1991 17.5962 15.4608C17.5962 14.7225 17.3029 14.0144 16.7808 13.4923C16.2588 12.9703 15.5507 12.677 14.8124 12.677Z"
      stroke={fill || '#6B6C7B'}
      strokeWidth="2.17778"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Digilocker.propTypes = {
  fill: PropTypes.string,
};

export default Digilocker;
